import React, { Component } from 'react';
import TextMessage from './TextMessage';
import EmojiMessage from './EmojiMessage';
import ImageMessage from './ImageMessage';
import chatIconUrl from './../../assets/chat-icon.svg';

class Message extends Component {
  _renderMessageOfType(type) {
    // eslint-disable-next-line default-case
    switch (type) {
      case 'text':
        return <TextMessage {...this.props.message} />;
      case 'emoji':
        return <EmojiMessage {...this.props.message} />;
      case 'image':
        return <ImageMessage {...this.props.message} />;
    }
  }

  render() {
    let contentClassList = [
      'sc-message--content',
      this.props.message.sender !== this.props.patientId ? 'sent' : 'received',
    ];
    return (
      <div className="sc-message">
        <div className={contentClassList.join(' ')}>
          <div
            className="sc-message--avatar"
            style={{
              backgroundImage: `url(${chatIconUrl})`,
            }}
          />
          {this._renderMessageOfType(this.props.message.type)}
        </div>
      </div>
    );
  }
}

export default Message;
